import i18n from 'i18next';
import { createContext } from 'react';
import type { LanguageListKeys } from '@/configs/i18n';
import { languageList } from '@/configs/i18n';
import { getUserLanguage, setUserLanguage } from './i18n';

export type I18nContextValue = ReturnType<typeof useI18nContextValue>;

export const i18nContext = createContext<I18nContextValue>({} as never);

export function useI18nContextValue() {
  const [language, setLanguage] = useState(getUserLanguage());

  const languageItem = useMemo(
    () =>
      languageList.findByKey(language as LanguageListKeys) ||
      languageList.findByKey('en')!,
    [language]
  );

  const setLanguage_ = useCallback<typeof i18n.changeLanguage>((lang, callback) => {
    setUserLanguage(lang);
    setLanguage(lang || getUserLanguage());
    return i18n.changeLanguage(lang, callback);
  }, []);

  const value = useMemo(
    () => ({ setLanguage: setLanguage_, language, languageItem, languageList }),
    [setLanguage_, language, languageItem]
  );

  return value;
}

export function useI18nContext() {
  return useContext(i18nContext);
}
